import { useContext } from "react";
import { Helmet } from "react-helmet";
import { MainLogo } from "../shared/MainLogo";
import styles from "../css/service.module.css";
import AppContext from "../contexts/appContext";

function AllServices() {
  const { menu } = useContext(AppContext);
  return (
    <>
      <Helmet>
        <title>Dailysocialboost | Services</title>
      </Helmet>
      <section className="container my-28 mx-auto px-24 text-center">
        <h2 className="my-5 text-3xl font-bold">All of our services</h2>
        <p className="font-semibold">
          Mauris rhoncus posuere dolor, eu mattis nunc. Aliquam elementum dolor eros, nec tempor
          metus tincidunt in. Suspendisse scelerisque magna vitae nulla pulvinar, id tincidunt mi
          accumsan.
        </p>
        <div className="my-20 flex flex-row md:flex-wrap lg:flex-row max-sm:flex-col justify-items-center">
          {menu
            ? menu.map((service, index) => (
                <div
                  key={index}
                  className={`flex flex-col items-center grow py-10 ${styles.servicesDiv}`}
                >
                  <a href={`/buy-${service.name.toLowerCase()}-services/${service.id}`}>
                    {MainLogo().HomeLogo(service.name.toLowerCase())}
                    <h4 className="text-xl font-semibold">{service.name}</h4>
                    <h5 className="text-lg font-semibold">Services</h5>
                  </a>
                </div>
              ))
            : null}
        </div>
      </section>
    </>
  );
}

export default AllServices;
